import { createContext } from 'react';

export const StatsigContext = createContext({
  initialized: false,
  loading: false,
  featureGates: {},
  experiments: {},
  dynamicConfigs: {}
});
